// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ArticleServiceCreateArticleData, ArticleServiceCreateArticleErrors, ArticleServiceCreateArticleResponses, ArticleServiceDeleteArticleData, ArticleServiceDeleteArticleErrors, ArticleServiceDeleteArticleResponses, ArticleServiceGetArticleData, ArticleServiceGetArticleErrors, ArticleServiceGetArticleResponses, ArticleServiceGetArticleTagsData, ArticleServiceGetArticleTagsErrors, ArticleServiceGetArticleTagsResponses, ArticleServiceGetReactionsData, ArticleServiceGetReactionsErrors, ArticleServiceGetReactionsResponses, ArticleServiceListArticlesData, ArticleServiceListArticlesErrors, ArticleServiceListArticlesResponses, ArticleServicePostReactionData, ArticleServicePostReactionErrors, ArticleServicePostReactionResponses, ArticleServiceUpdateArticleData, ArticleServiceUpdateArticleErrors, ArticleServiceUpdateArticleResponses, AuthServiceActivateData, AuthServiceActivateErrors, AuthServiceActivateResponses, AuthServiceAuthData, AuthServiceAuthErrors, AuthServiceAuthResponses, AuthServiceAuthUnlinkData, AuthServiceAuthUnlinkErrors, AuthServiceAuthUnlinkResponses, AuthServiceCompleteAccountLinkData, AuthServiceCompleteAccountLinkErrors, AuthServiceCompleteAccountLinkResponses, AuthServiceGetLinkedAccountData, AuthServiceGetLinkedAccountErrors, AuthServiceGetLinkedAccountResponses, AuthServiceListLinkedAccountsData, AuthServiceListLinkedAccountsErrors, AuthServiceListLinkedAccountsResponses, AuthServiceLoginData, AuthServiceLoginErrors, AuthServiceLoginResponses, AuthServiceLogoutData, AuthServiceLogoutErrors, AuthServiceLogoutResponses, AuthServiceRefreshLinkedAccountCredentialsData, AuthServiceRefreshLinkedAccountCredentialsErrors, AuthServiceRefreshLinkedAccountCredentialsResponses, AuthServiceRegisterData, AuthServiceRegisterErrors, AuthServiceRegisterResponses, AuthServiceStartAccountLinkData, AuthServiceStartAccountLinkErrors, AuthServiceStartAccountLinkResponses, AuthServiceUnlinkAccountData, AuthServiceUnlinkAccountErrors, AuthServiceUnlinkAccountResponses, BroadcastServiceBroadcastAccessData, BroadcastServiceBroadcastAccessErrors, BroadcastServiceBroadcastAccessResponses, BroadcastServiceDeleteBroadcastData, BroadcastServiceDeleteBroadcastErrors, BroadcastServiceDeleteBroadcastResponses, BroadcastServiceGetBroadcastData, BroadcastServiceGetBroadcastErrors, BroadcastServiceGetBroadcastResponses, BroadcastServiceGetCommunicationTokenData, BroadcastServiceGetCommunicationTokenErrors, BroadcastServiceGetCommunicationTokenResponses, BroadcastServiceListBroadcastsData, BroadcastServiceListBroadcastsErrors, BroadcastServiceListBroadcastsResponses, BroadcastServicePostBroadcastData, BroadcastServicePostBroadcastErrors, BroadcastServicePostBroadcastResponses, BroadcastServiceUpdateBroadcastData, BroadcastServiceUpdateBroadcastErrors, BroadcastServiceUpdateBroadcastResponses, ChatServiceAdminCreateRoomData, ChatServiceAdminCreateRoomErrors, ChatServiceAdminCreateRoomResponses, ChatServiceAdminCreateSpaceData, ChatServiceAdminCreateSpaceErrors, ChatServiceAdminCreateSpaceResponses, ChatServiceAdminListSpacesData, ChatServiceAdminListSpacesErrors, ChatServiceAdminListSpacesResponses, ChatServiceAdminRedactRoomMessageData, ChatServiceAdminRedactRoomMessageErrors, ChatServiceAdminRedactRoomMessageResponses, ChatServiceAdminSetArchiveRoomData, ChatServiceAdminSetArchiveRoomErrors, ChatServiceAdminSetArchiveRoomResponses, ChatServiceAdminSetBanRoomMemberData, ChatServiceAdminSetBanRoomMemberErrors, ChatServiceAdminSetBanRoomMemberResponses, ChatServiceListRoomMembersData, ChatServiceListRoomMembersErrors, ChatServiceListRoomMembersResponses, ChatServiceListRoomMessagesData, ChatServiceListRoomMessagesErrors, ChatServiceListRoomMessagesResponses, ChatServiceListSpaceRoomsData, ChatServiceListSpaceRoomsErrors, ChatServiceListSpaceRoomsResponses, ChatServiceSendRoomMessageData, ChatServiceSendRoomMessageErrors, ChatServiceSendRoomMessageReactionData, ChatServiceSendRoomMessageReactionErrors, ChatServiceSendRoomMessageReactionResponses, ChatServiceSendRoomMessageResponses, ChatServiceStreamRoomEventsData, ChatServiceStreamRoomEventsErrors, ChatServiceStreamRoomEventsResponses, ClubServiceCreateClubData, ClubServiceCreateClubErrors, ClubServiceCreateClubResponses, ClubServiceGetClubData, ClubServiceGetClubErrors, ClubServiceGetClubResponses, ClubServiceGetClubVoucherInfoData, ClubServiceGetClubVoucherInfoErrors, ClubServiceGetClubVoucherInfoResponses, ClubServiceListClubsData, ClubServiceListClubsErrors, ClubServiceListClubsResponses, ClubServiceRedeemClubVoucherData, ClubServiceRedeemClubVoucherErrors, ClubServiceRedeemClubVoucherResponses, FileServiceDeleteFileData, FileServiceDeleteFileErrors, FileServiceDeleteFileResponses, FileServiceGameRecordAccessData, FileServiceGameRecordAccessErrors, FileServiceGameRecordAccessResponses, FileServiceGetFileData, FileServiceGetFileDetailsData, FileServiceGetFileDetailsErrors, FileServiceGetFileDetailsResponses, FileServiceGetFileErrors, FileServiceGetFileResponses, FileServiceGetGamesStatisticsData, FileServiceGetGamesStatisticsErrors, FileServiceGetGamesStatisticsResponses, FileServiceListAvatarFormatsData, FileServiceListAvatarFormatsErrors, FileServiceListAvatarFormatsResponses, FileServiceListFeedbackFormatsData, FileServiceListFeedbackFormatsErrors, FileServiceListFeedbackFormatsResponses, FileServiceListFilesSelfData, FileServiceListFilesSelfErrors, FileServiceListFilesSelfResponses, FileServiceListGameRecordsData, FileServiceListGameRecordsErrors, FileServiceListGameRecordsResponses, FileServiceListGameRecordsSelfData, FileServiceListGameRecordsSelfErrors, FileServiceListGameRecordsSelfResponses, FileServiceListImageFormatsData, FileServiceListImageFormatsErrors, FileServiceListImageFormatsResponses, FileServiceUpdateGameRecordData, FileServiceUpdateGameRecordErrors, FileServiceUpdateGameRecordResponses, FileServiceUploadAvatarData, FileServiceUploadAvatarErrors, FileServiceUploadAvatarResponses, FileServiceUploadAvatarSelfData, FileServiceUploadAvatarSelfErrors, FileServiceUploadAvatarSelfResponses, FileServiceUploadFeedbackData, FileServiceUploadFeedbackErrors, FileServiceUploadFeedbackResponses, FileServiceUploadGameRecordData, FileServiceUploadGameRecordErrors, FileServiceUploadGameRecordNewData, FileServiceUploadGameRecordNewErrors, FileServiceUploadGameRecordNewResponses, FileServiceUploadGameRecordResponses, FileServiceUploadImageData, FileServiceUploadImageErrors, FileServiceUploadImageResponses, GameServiceAcceptChallengeData, GameServiceAcceptChallengeErrors, GameServiceAcceptChallengeResponses, GameServiceCancelChallengeData, GameServiceCancelChallengeErrors, GameServiceCancelChallengeResponses, GameServiceGetChallengeData, GameServiceGetChallengeErrors, GameServiceGetChallengeResponses, GameServiceListChallengesData, GameServiceListChallengesErrors, GameServiceListChallengesResponses, GameServiceListChallengesSelfData, GameServiceListChallengesSelfErrors, GameServiceListChallengesSelfResponses, GameServiceListChatRoomsData, GameServiceListChatRoomsErrors, GameServiceListChatRoomsResponses, GameServiceListGamesCurrentData, GameServiceListGamesCurrentErrors, GameServiceListGamesCurrentResponses, GameServiceListGamesData, GameServiceListGamesErrors, GameServiceListGamesResponses, GameServiceListGamesSelfData, GameServiceListGamesSelfErrors, GameServiceListGamesSelfResponses, GameServicePostChallengeData, GameServicePostChallengeErrors, GameServicePostChallengeResponses, GameServiceStreamChallengesData, GameServiceStreamChallengesErrors, GameServiceStreamChallengesResponses, LocationServiceListLocationsChildrenData, LocationServiceListLocationsChildrenErrors, LocationServiceListLocationsChildrenResponses, LocationServiceListLocationsData, LocationServiceListLocationsErrors, LocationServiceListLocationsResponses, LogServiceDeleteNotifyData, LogServiceDeleteNotifyErrors, LogServiceDeleteNotifyResponses, LogServiceListNotificationsData, LogServiceListNotificationsErrors, LogServiceListNotificationsResponses, LogServicePostLogData, LogServicePostLogErrors, LogServicePostLogResponses, LogServiceReadNotifyData, LogServiceReadNotifyErrors, LogServiceReadNotifyResponses, LogServiceStreamNotificationsData, LogServiceStreamNotificationsErrors, LogServiceStreamNotificationsResponses, PaymentServiceCastDonationVotesData, PaymentServiceCastDonationVotesErrors, PaymentServiceCastDonationVotesResponses, PaymentServiceCreatePaymentData, PaymentServiceCreatePaymentErrors, PaymentServiceCreatePaymentResponses, PaymentServiceGetDonationData, PaymentServiceGetDonationErrors, PaymentServiceGetDonationResponses, PaymentServiceGetDonationsInfoData, PaymentServiceGetDonationsInfoErrors, PaymentServiceGetDonationsInfoResponses, PaymentServiceGetDonationsSelfData, PaymentServiceGetDonationsSelfErrors, PaymentServiceGetDonationsSelfResponses, PaymentServiceGetDonationsTotalsData, PaymentServiceGetDonationsTotalsErrors, PaymentServiceGetDonationsTotalsResponses, PaymentServiceGetVoucherInfoData, PaymentServiceGetVoucherInfoErrors, PaymentServiceGetVoucherInfoResponses, PaymentServiceListDonationsData, PaymentServiceListDonationsErrors, PaymentServiceListDonationsResponses, PaymentServiceListDonationVotesData, PaymentServiceListDonationVotesErrors, PaymentServiceListDonationVotesResponses, PlayerServiceGetPlayerData, PlayerServiceGetPlayerErrors, PlayerServiceGetPlayerResponses, PlayerServiceGetPlayersStatisticsData, PlayerServiceGetPlayersStatisticsErrors, PlayerServiceGetPlayersStatisticsResponses, PlayerServiceListPlayerRatingData, PlayerServiceListPlayerRatingErrors, PlayerServiceListPlayerRatingResponses, PlayerServiceListPlayersData, PlayerServiceListPlayersErrors, PlayerServiceListPlayersLocationsData, PlayerServiceListPlayersLocationsErrors, PlayerServiceListPlayersLocationsResponses, PlayerServiceListPlayersResponses, PlayerServiceListPlayerTournamentsData, PlayerServiceListPlayerTournamentsErrors, PlayerServiceListPlayerTournamentsResponses, PollServiceAddPollOptionsData, PollServiceAddPollOptionsErrors, PollServiceAddPollOptionsResponses, PollServiceCastPollVotesData, PollServiceCastPollVotesErrors, PollServiceCastPollVotesResponses, PollServiceCreatePollData, PollServiceCreatePollErrors, PollServiceCreatePollResponses, PollServiceDeletePollData, PollServiceDeletePollErrors, PollServiceDeletePollOptionData, PollServiceDeletePollOptionErrors, PollServiceDeletePollOptionResponses, PollServiceDeletePollResponses, PollServiceGetPollData, PollServiceGetPollErrors, PollServiceGetPollResponses, PollServiceListPollsData, PollServiceListPollsErrors, PollServiceListPollsResponses, PollServiceOrderPollOptionsData, PollServiceOrderPollOptionsErrors, PollServiceOrderPollOptionsResponses, PollServiceUpdatePollData, PollServiceUpdatePollErrors, PollServiceUpdatePollOptionData, PollServiceUpdatePollOptionErrors, PollServiceUpdatePollOptionResponses, PollServiceUpdatePollResponses, ProfileServiceAdminRenameProfileData, ProfileServiceAdminRenameProfileErrors, ProfileServiceAdminRenameProfileResponses, ProfileServiceGetProfileData, ProfileServiceGetProfileErrors, ProfileServiceGetProfileResponses, ProfileServiceGetStatisticsData, ProfileServiceGetStatisticsErrors, ProfileServiceGetStatisticsResponses, ProfileServiceListPlayerGamesData, ProfileServiceListPlayerGamesErrors, ProfileServiceListPlayerGamesResponses, ProfileServiceListPlayerOpponentsData, ProfileServiceListPlayerOpponentsErrors, ProfileServiceListPlayerOpponentsResponses, RatingServiceGetFormData, RatingServiceGetFormErrors, RatingServiceGetFormResponses, RatingServiceListRatingHistoryData, RatingServiceListRatingHistoryErrors, RatingServiceListRatingHistoryResponses, RefereeServiceAddTournamentPersonnelData, RefereeServiceAddTournamentPersonnelErrors, RefereeServiceAddTournamentPersonnelResponses, RefereeServiceAddTournamentStageData, RefereeServiceAddTournamentStageErrors, RefereeServiceAddTournamentStageResponses, RefereeServiceCreateParticipantData, RefereeServiceCreateParticipantErrors, RefereeServiceCreateParticipantResponses, RefereeServiceCreateTournamentData, RefereeServiceCreateTournamentErrors, RefereeServiceCreateTournamentResponses, RefereeServiceDeletePersonnelData, RefereeServiceDeletePersonnelErrors, RefereeServiceDeletePersonnelResponses, RefereeServiceDeleteStageData, RefereeServiceDeleteStageErrors, RefereeServiceDeleteStageResponses, RefereeServiceDeleteTournamentData, RefereeServiceDeleteTournamentErrors, RefereeServiceDeleteTournamentResponses, RefereeServiceGetTournamentData, RefereeServiceGetTournamentErrors, RefereeServiceGetTournamentResponses, RefereeServiceListParticipantsData, RefereeServiceListParticipantsErrors, RefereeServiceListParticipantsResponses, RefereeServiceListTournamentsData, RefereeServiceListTournamentsErrors, RefereeServiceListTournamentsResponses, RefereeServiceRegistrationFormFieldsData, RefereeServiceRegistrationFormFieldsErrors, RefereeServiceRegistrationFormFieldsResponses, RefereeServiceSeedGroupsTestData, RefereeServiceSeedGroupsTestErrors, RefereeServiceSeedGroupsTestResponses, RefereeServiceSeedRoundsTestData, RefereeServiceSeedRoundsTestErrors, RefereeServiceSeedRoundsTestResponses, RefereeServiceUpdateParticipantData, RefereeServiceUpdateParticipantErrors, RefereeServiceUpdateParticipantResponses, RefereeServiceUpdatePersonnelData, RefereeServiceUpdatePersonnelErrors, RefereeServiceUpdatePersonnelResponses, RefereeServiceUpdatePrizeInfoData, RefereeServiceUpdatePrizeInfoErrors, RefereeServiceUpdatePrizeInfoResponses, RefereeServiceUpdateRegistrationFormData, RefereeServiceUpdateRegistrationFormErrors, RefereeServiceUpdateRegistrationFormResponses, RefereeServiceUpdateStageData, RefereeServiceUpdateStageErrors, RefereeServiceUpdateStageResponses, RefereeServiceUpdateTournamentData, RefereeServiceUpdateTournamentErrors, RefereeServiceUpdateTournamentResponses, ServerHubServiceAcceptChallengeData, ServerHubServiceAcceptChallengeErrors, ServerHubServiceAcceptChallengeResponses, ServerHubServiceCancelChallengeData, ServerHubServiceCancelChallengeErrors, ServerHubServiceCancelChallengeResponses, ServerHubServiceCreateChallengeData, ServerHubServiceCreateChallengeErrors, ServerHubServiceCreateChallengeResponses, ServerHubServiceFindMatchData, ServerHubServiceFindMatchErrors, ServerHubServiceFindMatchResponses, ServerHubServiceGetGameRecordData, ServerHubServiceGetGameRecordErrors, ServerHubServiceGetGameRecordResponses, ServerHubServiceListChallengesData, ServerHubServiceListChallengesErrors, ServerHubServiceListChallengesResponses, ServerHubServiceListMatchmakingOptionsData, ServerHubServiceListMatchmakingOptionsErrors, ServerHubServiceListMatchmakingOptionsResponses, ServerHubServiceListProvidersData, ServerHubServiceListProvidersErrors, ServerHubServiceListProvidersResponses, ServerHubServiceSearchPlayersData, ServerHubServiceSearchPlayersErrors, ServerHubServiceSearchPlayersResponses, ServerHubServiceSendGameCommandData, ServerHubServiceSendGameCommandErrors, ServerHubServiceSendGameCommandResponses, ServerHubServiceStreamGameData, ServerHubServiceStreamGameErrors, ServerHubServiceStreamGameResponses, ServerServiceAcceptDeadStonesData, ServerServiceAcceptDeadStonesErrors, ServerServiceAcceptDeadStonesResponses, ServerServiceAcceptUndoData, ServerServiceAcceptUndoErrors, ServerServiceAcceptUndoResponses, ServerServiceAiRefereeData, ServerServiceAiRefereeErrors, ServerServiceAiRefereeResponses, ServerServiceBroadcastBackData, ServerServiceBroadcastBackErrors, ServerServiceBroadcastBackResponses, ServerServiceBroadcastChatData, ServerServiceBroadcastChatErrors, ServerServiceBroadcastChatResponses, ServerServiceBroadcastCutData, ServerServiceBroadcastCutErrors, ServerServiceBroadcastCutResponses, ServerServiceBroadcastMoveData, ServerServiceBroadcastMoveErrors, ServerServiceBroadcastMoveResponses, ServerServiceBroadcastPassData, ServerServiceBroadcastPassErrors, ServerServiceBroadcastPassResponses, ServerServiceBroadcastPruneData, ServerServiceBroadcastPruneErrors, ServerServiceBroadcastPruneResponses, ServerServiceBroadcastResultData, ServerServiceBroadcastResultErrors, ServerServiceBroadcastResultResponses, ServerServiceBroadcastSetCurrentNodeData, ServerServiceBroadcastSetCurrentNodeErrors, ServerServiceBroadcastSetCurrentNodeResponses, ServerServiceBroadcastSetNodeMetadataData, ServerServiceBroadcastSetNodeMetadataErrors, ServerServiceBroadcastSetNodeMetadataResponses, ServerServiceBroadcastSgfData, ServerServiceBroadcastSgfErrors, ServerServiceBroadcastSgfResponses, ServerServiceBroadcastUndoData, ServerServiceBroadcastUndoErrors, ServerServiceBroadcastUndoResponses, ServerServiceBroadcastUploadSgfData, ServerServiceBroadcastUploadSgfErrors, ServerServiceBroadcastUploadSgfResponses, ServerServiceGameChatData, ServerServiceGameChatErrors, ServerServiceGameChatResponses, ServerServiceGameMoveData, ServerServiceGameMoveErrors, ServerServiceGameMoveResponses, ServerServiceGamePassData, ServerServiceGamePassErrors, ServerServiceGamePassResponses, ServerServiceGameResignData, ServerServiceGameResignErrors, ServerServiceGameResignResponses, ServerServiceGameSgfData, ServerServiceGameSgfErrors, ServerServiceGameSgfResponses, ServerServiceRejectDeadStonesData, ServerServiceRejectDeadStonesErrors, ServerServiceRejectDeadStonesResponses, ServerServiceRejectUndoData, ServerServiceRejectUndoErrors, ServerServiceRejectUndoResponses, ServerServiceRequestUndoData, ServerServiceRequestUndoErrors, ServerServiceRequestUndoResponses, ServerServiceStreamBroadcastData, ServerServiceStreamBroadcastErrors, ServerServiceStreamBroadcastResponses, ServerServiceStreamGameData, ServerServiceStreamGameErrors, ServerServiceStreamGameResponses, ServerServiceToggleDeadStonesData, ServerServiceToggleDeadStonesErrors, ServerServiceToggleDeadStonesResponses, StudyServiceApplyParticipantData, StudyServiceApplyParticipantErrors, StudyServiceApplyParticipantResponses, StudyServiceCreateCoachData, StudyServiceCreateCoachErrors, StudyServiceCreateCoachResponses, StudyServiceCreateProductData, StudyServiceCreateProductErrors, StudyServiceCreateProductResponses, StudyServiceDeleteCoachData, StudyServiceDeleteCoachErrors, StudyServiceDeleteCoachResponses, StudyServiceDeleteProductData, StudyServiceDeleteProductErrors, StudyServiceDeleteProductResponses, StudyServiceGetCoachData, StudyServiceGetCoachErrors, StudyServiceGetCoachResponses, StudyServiceGetProductData, StudyServiceGetProductErrors, StudyServiceGetProductResponses, StudyServiceListCoachesData, StudyServiceListCoachesErrors, StudyServiceListCoachesResponses, StudyServiceListProductsData, StudyServiceListProductsErrors, StudyServiceListProductsResponses, StudyServiceRemoveParticipantData, StudyServiceRemoveParticipantErrors, StudyServiceRemoveParticipantResponses, StudyServiceUpdateCoachData, StudyServiceUpdateCoachErrors, StudyServiceUpdateCoachResponses, StudyServiceUpdateProductData, StudyServiceUpdateProductErrors, StudyServiceUpdateProductResponses, TournamentServiceAdminTournamentIgnoreData, TournamentServiceAdminTournamentIgnoreErrors, TournamentServiceAdminTournamentIgnoreResponses, TournamentServiceAdminTournamentLocationData, TournamentServiceAdminTournamentLocationErrors, TournamentServiceAdminTournamentLocationResponses, TournamentServiceAdminTournamentPinData, TournamentServiceAdminTournamentPinErrors, TournamentServiceAdminTournamentPinResponses, TournamentServiceAdminTournamentProcessData, TournamentServiceAdminTournamentProcessErrors, TournamentServiceAdminTournamentProcessResponses, TournamentServiceAdminTournamentsLocationsData, TournamentServiceAdminTournamentsLocationsErrors, TournamentServiceAdminTournamentsLocationsResponses, TournamentServiceGetTournamentData, TournamentServiceGetTournamentErrors, TournamentServiceGetTournamentPerformanceData, TournamentServiceGetTournamentPerformanceErrors, TournamentServiceGetTournamentPerformanceResponses, TournamentServiceGetTournamentResponses, TournamentServiceGetTournamentsStatisticsData, TournamentServiceGetTournamentsStatisticsErrors, TournamentServiceGetTournamentsStatisticsResponses, TournamentServiceGetTournamentStatisticsData, TournamentServiceGetTournamentStatisticsErrors, TournamentServiceGetTournamentStatisticsResponses, TournamentServiceListTournamentGamesData, TournamentServiceListTournamentGamesErrors, TournamentServiceListTournamentGamesResponses, TournamentServiceListTournamentsData, TournamentServiceListTournamentsErrors, TournamentServiceListTournamentsLocationsData, TournamentServiceListTournamentsLocationsErrors, TournamentServiceListTournamentsLocationsResponses, TournamentServiceListTournamentsResponses, UserServiceActivatePasswordCodeData, UserServiceActivatePasswordCodeErrors, UserServiceActivatePasswordCodeResponses, UserServiceAdminLinkUserData, UserServiceAdminLinkUserErrors, UserServiceAdminLinkUserResponses, UserServiceAdminUpdateRoleData, UserServiceAdminUpdateRoleErrors, UserServiceAdminUpdateRoleResponses, UserServiceCheckPasswordCodeData, UserServiceCheckPasswordCodeErrors, UserServiceCheckPasswordCodeResponses, UserServiceDeleteAvatarSelfData, UserServiceDeleteAvatarSelfErrors, UserServiceDeleteAvatarSelfResponses, UserServiceDeleteUserData, UserServiceDeleteUserErrors, UserServiceDeleteUserResponses, UserServiceDeleteUserSelfData, UserServiceDeleteUserSelfErrors, UserServiceDeleteUserSelfResponses, UserServiceGetUserData, UserServiceGetUserErrors, UserServiceGetUserInfoData, UserServiceGetUserInfoErrors, UserServiceGetUserInfoResponses, UserServiceGetUserInfoSelfData, UserServiceGetUserInfoSelfErrors, UserServiceGetUserInfoSelfResponses, UserServiceGetUserPlayerData, UserServiceGetUserPlayerErrors, UserServiceGetUserPlayerResponses, UserServiceGetUserResponses, UserServiceGetUserSelfData, UserServiceGetUserSelfErrors, UserServiceGetUserSelfResponses, UserServiceGiveConsentData, UserServiceGiveConsentErrors, UserServiceGiveConsentResponses, UserServiceListUserLoginDetailsData, UserServiceListUserLoginDetailsErrors, UserServiceListUserLoginDetailsResponses, UserServiceListUsersData, UserServiceListUsersErrors, UserServiceListUsersResponses, UserServiceListUsersRolesData, UserServiceListUsersRolesErrors, UserServiceListUsersRolesResponses, UserServicePostFeedbackData, UserServicePostFeedbackErrors, UserServicePostFeedbackResponses, UserServiceResetPasswordData, UserServiceResetPasswordErrors, UserServiceResetPasswordResponses, UserServiceSetUserRankData, UserServiceSetUserRankErrors, UserServiceSetUserRankResponses, UserServiceUpdatePasswordData, UserServiceUpdatePasswordErrors, UserServiceUpdatePasswordResponses, UserServiceUpdateUserInfoData, UserServiceUpdateUserInfoErrors, UserServiceUpdateUserInfoResponses, UserServiceUpdateUserInfoSelfData, UserServiceUpdateUserInfoSelfErrors, UserServiceUpdateUserInfoSelfResponses, UserServiceUpdateUsernameData, UserServiceUpdateUsernameErrors, UserServiceUpdateUsernameResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const serverHubServiceListProviders = <ThrowOnError extends boolean = false>(options?: Options<ServerHubServiceListProvidersData, ThrowOnError>) => (options?.client ?? client).get<ServerHubServiceListProvidersResponses, ServerHubServiceListProvidersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers',
    ...options
});

export const serverHubServiceListChallenges = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceListChallengesData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceListChallengesResponses, ServerHubServiceListChallengesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/challenges',
    ...options
});

export const serverHubServiceCreateChallenge = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceCreateChallengeData, ThrowOnError>) => (options.client ?? client).post<ServerHubServiceCreateChallengeResponses, ServerHubServiceCreateChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/challenges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverHubServiceCancelChallenge = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceCancelChallengeData, ThrowOnError>) => (options.client ?? client).delete<ServerHubServiceCancelChallengeResponses, ServerHubServiceCancelChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/challenges/{externalChallengeId}',
    ...options
});

export const serverHubServiceAcceptChallenge = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceAcceptChallengeData, ThrowOnError>) => (options.client ?? client).post<ServerHubServiceAcceptChallengeResponses, ServerHubServiceAcceptChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/challenges/{externalChallengeId}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Commands are not idempotent and server-hub does not retry them. After an
 * ambiguous timeout, consumers must use StreamGame as the source of truth.
 */
export const serverHubServiceSendGameCommand = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceSendGameCommandData, ThrowOnError>) => (options.client ?? client).post<ServerHubServiceSendGameCommandResponses, ServerHubServiceSendGameCommandErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/games/{externalGameId}/commands',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverHubServiceGetGameRecord = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceGetGameRecordData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceGetGameRecordResponses, ServerHubServiceGetGameRecordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/games/{externalGameId}/record',
    ...options
});

/**
 * The stream owns a process-local provider subscription. Reopening it yields
 * a current baseline; event IDs are ordering hints, not durable resume cursors.
 */
export const serverHubServiceStreamGame = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceStreamGameData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceStreamGameResponses, ServerHubServiceStreamGameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/games/{externalGameId}/stream',
    ...options
});

/**
 * The search is tied to the stream context. Disconnecting triggers a
 * best-effort provider cancellation; searches are not persisted by the hub.
 */
export const serverHubServiceFindMatch = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceFindMatchData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceFindMatchResponses, ServerHubServiceFindMatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/matchmaking',
    ...options
});

export const serverHubServiceListMatchmakingOptions = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceListMatchmakingOptionsData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceListMatchmakingOptionsResponses, ServerHubServiceListMatchmakingOptionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/matchmaking/options',
    ...options
});

export const serverHubServiceSearchPlayers = <ThrowOnError extends boolean = false>(options: Options<ServerHubServiceSearchPlayersData, ThrowOnError>) => (options.client ?? client).get<ServerHubServiceSearchPlayersResponses, ServerHubServiceSearchPlayersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/hub/providers/{providerId}/players',
    ...options
});

export const playerServiceListPlayers = <ThrowOnError extends boolean = false>(options?: Options<PlayerServiceListPlayersData, ThrowOnError>) => (options?.client ?? client).get<PlayerServiceListPlayersResponses, PlayerServiceListPlayersErrors, ThrowOnError>({ url: '/players', ...options });

export const playerServiceGetPlayer = <ThrowOnError extends boolean = false>(options: Options<PlayerServiceGetPlayerData, ThrowOnError>) => (options.client ?? client).get<PlayerServiceGetPlayerResponses, PlayerServiceGetPlayerErrors, ThrowOnError>({ url: '/players/{id}', ...options });

export const playerServiceListPlayerRating = <ThrowOnError extends boolean = false>(options: Options<PlayerServiceListPlayerRatingData, ThrowOnError>) => (options.client ?? client).get<PlayerServiceListPlayerRatingResponses, PlayerServiceListPlayerRatingErrors, ThrowOnError>({ url: '/players/{id}/rating', ...options });

export const playerServiceListPlayerTournaments = <ThrowOnError extends boolean = false>(options: Options<PlayerServiceListPlayerTournamentsData, ThrowOnError>) => (options.client ?? client).get<PlayerServiceListPlayerTournamentsResponses, PlayerServiceListPlayerTournamentsErrors, ThrowOnError>({ url: '/players/{id}/tournaments', ...options });

export const playerServiceListPlayersLocations = <ThrowOnError extends boolean = false>(options?: Options<PlayerServiceListPlayersLocationsData, ThrowOnError>) => (options?.client ?? client).get<PlayerServiceListPlayersLocationsResponses, PlayerServiceListPlayersLocationsErrors, ThrowOnError>({ url: '/players:locations', ...options });

export const playerServiceGetPlayersStatistics = <ThrowOnError extends boolean = false>(options?: Options<PlayerServiceGetPlayersStatisticsData, ThrowOnError>) => (options?.client ?? client).get<PlayerServiceGetPlayersStatisticsResponses, PlayerServiceGetPlayersStatisticsErrors, ThrowOnError>({ url: '/players:statistics', ...options });

export const locationServiceListLocations = <ThrowOnError extends boolean = false>(options?: Options<LocationServiceListLocationsData, ThrowOnError>) => (options?.client ?? client).get<LocationServiceListLocationsResponses, LocationServiceListLocationsErrors, ThrowOnError>({ url: '/locations', ...options });

export const locationServiceListLocationsChildren = <ThrowOnError extends boolean = false>(options?: Options<LocationServiceListLocationsChildrenData, ThrowOnError>) => (options?.client ?? client).get<LocationServiceListLocationsChildrenResponses, LocationServiceListLocationsChildrenErrors, ThrowOnError>({ url: '/locations/children', ...options });

export const authServiceActivate = <ThrowOnError extends boolean = false>(options: Options<AuthServiceActivateData, ThrowOnError>) => (options.client ?? client).get<AuthServiceActivateResponses, AuthServiceActivateErrors, ThrowOnError>({ url: '/activate/{code}', ...options });

/**
 * Linked game accounts are intentionally kept as a distinct WIP API. They
 * are not login methods and should not inherit the legacy Auth naming.
 */
export const authServiceListLinkedAccounts = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceListLinkedAccountsData, ThrowOnError>) => (options?.client ?? client).get<AuthServiceListLinkedAccountsResponses, AuthServiceListLinkedAccountsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/links',
    ...options
});

export const authServiceCompleteAccountLink = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceCompleteAccountLinkData, ThrowOnError>) => (options?.client ?? client).get<AuthServiceCompleteAccountLinkResponses, AuthServiceCompleteAccountLinkErrors, ThrowOnError>({ url: '/auth/links/oauth/callback', ...options });

export const authServiceUnlinkAccount = <ThrowOnError extends boolean = false>(options: Options<AuthServiceUnlinkAccountData, ThrowOnError>) => (options.client ?? client).delete<AuthServiceUnlinkAccountResponses, AuthServiceUnlinkAccountErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/links/{federation}',
    ...options
});

export const authServiceGetLinkedAccount = <ThrowOnError extends boolean = false>(options: Options<AuthServiceGetLinkedAccountData, ThrowOnError>) => (options.client ?? client).get<AuthServiceGetLinkedAccountResponses, AuthServiceGetLinkedAccountErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/links/{federation}',
    ...options
});

export const authServiceStartAccountLink = <ThrowOnError extends boolean = false>(options: Options<AuthServiceStartAccountLinkData, ThrowOnError>) => (options.client ?? client).post<AuthServiceStartAccountLinkResponses, AuthServiceStartAccountLinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/links/{federation}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin/Sandbox/testing endpoint. Production consumers should use the lazy
 * credential refresh performed by GetLinkedAccountCredentials.
 */
export const authServiceRefreshLinkedAccountCredentials = <ThrowOnError extends boolean = false>(options: Options<AuthServiceRefreshLinkedAccountCredentialsData, ThrowOnError>) => (options.client ?? client).post<AuthServiceRefreshLinkedAccountCredentialsResponses, AuthServiceRefreshLinkedAccountCredentialsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/links/{federation}/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceAuthUnlink = <ThrowOnError extends boolean = false>(options: Options<AuthServiceAuthUnlinkData, ThrowOnError>) => (options.client ?? client).delete<AuthServiceAuthUnlinkResponses, AuthServiceAuthUnlinkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/auth/{provider}',
    ...options
});

/**
 * TODO(auth-api): Auth/AuthCallback/AuthUnlink describe provider login; a
 * future version could call them Start/Complete/UnlinkProviderLogin.
 */
export const authServiceAuth = <ThrowOnError extends boolean = false>(options: Options<AuthServiceAuthData, ThrowOnError>) => (options.client ?? client).get<AuthServiceAuthResponses, AuthServiceAuthErrors, ThrowOnError>({ url: '/auth/{provider}', ...options });

export const authServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLoginData, ThrowOnError>) => (options.client ?? client).post<AuthServiceLoginResponses, AuthServiceLoginErrors, ThrowOnError>({
    url: '/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authServiceLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceLogoutData, ThrowOnError>) => (options?.client ?? client).get<AuthServiceLogoutResponses, AuthServiceLogoutErrors, ThrowOnError>({ url: '/logout', ...options });

export const authServiceRegister = <ThrowOnError extends boolean = false>(options: Options<AuthServiceRegisterData, ThrowOnError>) => (options.client ?? client).post<AuthServiceRegisterResponses, AuthServiceRegisterErrors, ThrowOnError>({
    url: '/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const profileServiceAdminRenameProfile = <ThrowOnError extends boolean = false>(options: Options<ProfileServiceAdminRenameProfileData, ThrowOnError>) => (options.client ?? client).patch<ProfileServiceAdminRenameProfileResponses, ProfileServiceAdminRenameProfileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/profile/rename/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const profileServiceGetProfile = <ThrowOnError extends boolean = false>(options: Options<ProfileServiceGetProfileData, ThrowOnError>) => (options.client ?? client).get<ProfileServiceGetProfileResponses, ProfileServiceGetProfileErrors, ThrowOnError>({ url: '/profile/{id}', ...options });

export const profileServiceListPlayerGames = <ThrowOnError extends boolean = false>(options: Options<ProfileServiceListPlayerGamesData, ThrowOnError>) => (options.client ?? client).get<ProfileServiceListPlayerGamesResponses, ProfileServiceListPlayerGamesErrors, ThrowOnError>({ url: '/profile/{id}/games', ...options });

export const profileServiceListPlayerOpponents = <ThrowOnError extends boolean = false>(options: Options<ProfileServiceListPlayerOpponentsData, ThrowOnError>) => (options.client ?? client).get<ProfileServiceListPlayerOpponentsResponses, ProfileServiceListPlayerOpponentsErrors, ThrowOnError>({ url: '/profile/{id}/opponents', ...options });

export const profileServiceGetStatistics = <ThrowOnError extends boolean = false>(options: Options<ProfileServiceGetStatisticsData, ThrowOnError>) => (options.client ?? client).get<ProfileServiceGetStatisticsResponses, ProfileServiceGetStatisticsErrors, ThrowOnError>({ url: '/profile/{id}/statistics', ...options });

export const fileServiceUploadAvatar = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadAvatarData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadAvatarResponses, FileServiceUploadAvatarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/avatars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceListAvatarFormats = <ThrowOnError extends boolean = false>(options?: Options<FileServiceListAvatarFormatsData, ThrowOnError>) => (options?.client ?? client).get<FileServiceListAvatarFormatsResponses, FileServiceListAvatarFormatsErrors, ThrowOnError>({ url: '/files/avatars:formats', ...options });

export const fileServiceUploadAvatarSelf = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadAvatarSelfData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadAvatarSelfResponses, FileServiceUploadAvatarSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/avatars:self',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceUploadFeedback = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadFeedbackData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadFeedbackResponses, FileServiceUploadFeedbackErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceListFeedbackFormats = <ThrowOnError extends boolean = false>(options?: Options<FileServiceListFeedbackFormatsData, ThrowOnError>) => (options?.client ?? client).get<FileServiceListFeedbackFormatsResponses, FileServiceListFeedbackFormatsErrors, ThrowOnError>({ url: '/files/feedback:formats', ...options });

export const fileServiceUploadGameRecordNew = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadGameRecordNewData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadGameRecordNewResponses, FileServiceUploadGameRecordNewErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/games',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceListGameRecords = <ThrowOnError extends boolean = false>(options: Options<FileServiceListGameRecordsData, ThrowOnError>) => (options.client ?? client).get<FileServiceListGameRecordsResponses, FileServiceListGameRecordsErrors, ThrowOnError>({ url: '/files/games/{id}', ...options });

export const fileServiceUpdateGameRecord = <ThrowOnError extends boolean = false>(options: Options<FileServiceUpdateGameRecordData, ThrowOnError>) => (options.client ?? client).patch<FileServiceUpdateGameRecordResponses, FileServiceUpdateGameRecordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/games/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceUploadGameRecord = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadGameRecordData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadGameRecordResponses, FileServiceUploadGameRecordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/games/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceListGameRecordsSelf = <ThrowOnError extends boolean = false>(options?: Options<FileServiceListGameRecordsSelfData, ThrowOnError>) => (options?.client ?? client).get<FileServiceListGameRecordsSelfResponses, FileServiceListGameRecordsSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/games:self',
    ...options
});

export const fileServiceGetGamesStatistics = <ThrowOnError extends boolean = false>(options?: Options<FileServiceGetGamesStatisticsData, ThrowOnError>) => (options?.client ?? client).get<FileServiceGetGamesStatisticsResponses, FileServiceGetGamesStatisticsErrors, ThrowOnError>({ url: '/files/games:statistics', ...options });

export const fileServiceUploadImage = <ThrowOnError extends boolean = false>(options: Options<FileServiceUploadImageData, ThrowOnError>) => (options.client ?? client).post<FileServiceUploadImageResponses, FileServiceUploadImageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceListImageFormats = <ThrowOnError extends boolean = false>(options?: Options<FileServiceListImageFormatsData, ThrowOnError>) => (options?.client ?? client).get<FileServiceListImageFormatsResponses, FileServiceListImageFormatsErrors, ThrowOnError>({ url: '/files/images:formats', ...options });

export const fileServiceGameRecordAccess = <ThrowOnError extends boolean = false>(options: Options<FileServiceGameRecordAccessData, ThrowOnError>) => (options.client ?? client).patch<FileServiceGameRecordAccessResponses, FileServiceGameRecordAccessErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{gid}/users/{userId}:access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fileServiceDeleteFile = <ThrowOnError extends boolean = false>(options: Options<FileServiceDeleteFileData, ThrowOnError>) => (options.client ?? client).delete<FileServiceDeleteFileResponses, FileServiceDeleteFileErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files/{id}',
    ...options
});

export const fileServiceGetFile = <ThrowOnError extends boolean = false>(options: Options<FileServiceGetFileData, ThrowOnError>) => (options.client ?? client).get<FileServiceGetFileResponses, FileServiceGetFileErrors, ThrowOnError>({ url: '/files/{id}', ...options });

export const fileServiceGetFileDetails = <ThrowOnError extends boolean = false>(options: Options<FileServiceGetFileDetailsData, ThrowOnError>) => (options.client ?? client).get<FileServiceGetFileDetailsResponses, FileServiceGetFileDetailsErrors, ThrowOnError>({ url: '/files/{id}:details', ...options });

export const fileServiceListFilesSelf = <ThrowOnError extends boolean = false>(options?: Options<FileServiceListFilesSelfData, ThrowOnError>) => (options?.client ?? client).get<FileServiceListFilesSelfResponses, FileServiceListFilesSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/files:self',
    ...options
});

export const userServiceAdminLinkUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceAdminLinkUserData, ThrowOnError>) => (options.client ?? client).patch<UserServiceAdminLinkUserResponses, UserServiceAdminLinkUserErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/user/{id}/link/{pid}',
    ...options
});

export const userServiceAdminUpdateRole = <ThrowOnError extends boolean = false>(options: Options<UserServiceAdminUpdateRoleData, ThrowOnError>) => (options.client ?? client).post<UserServiceAdminUpdateRoleResponses, UserServiceAdminUpdateRoleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/user/{id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServicePostFeedback = <ThrowOnError extends boolean = false>(options: Options<UserServicePostFeedbackData, ThrowOnError>) => (options.client ?? client).post<UserServicePostFeedbackResponses, UserServicePostFeedbackErrors, ThrowOnError>({
    url: '/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<UserServiceListUsersData, ThrowOnError>) => (options?.client ?? client).get<UserServiceListUsersResponses, UserServiceListUsersErrors, ThrowOnError>({ url: '/users', ...options });

export const userServiceDeleteAvatarSelf = <ThrowOnError extends boolean = false>(options?: Options<UserServiceDeleteAvatarSelfData, ThrowOnError>) => (options?.client ?? client).delete<UserServiceDeleteAvatarSelfResponses, UserServiceDeleteAvatarSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/avatar:self',
    ...options
});

export const userServiceGiveConsent = <ThrowOnError extends boolean = false>(options?: Options<UserServiceGiveConsentData, ThrowOnError>) => (options?.client ?? client).patch<UserServiceGiveConsentResponses, UserServiceGiveConsentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/consent:self',
    ...options
});

export const userServiceGetUserInfo = <ThrowOnError extends boolean = false>(options: Options<UserServiceGetUserInfoData, ThrowOnError>) => (options.client ?? client).get<UserServiceGetUserInfoResponses, UserServiceGetUserInfoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/info/{id}',
    ...options
});

export const userServiceUpdateUserInfo = <ThrowOnError extends boolean = false>(options: Options<UserServiceUpdateUserInfoData, ThrowOnError>) => (options.client ?? client).patch<UserServiceUpdateUserInfoResponses, UserServiceUpdateUserInfoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/info/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceGetUserInfoSelf = <ThrowOnError extends boolean = false>(options?: Options<UserServiceGetUserInfoSelfData, ThrowOnError>) => (options?.client ?? client).get<UserServiceGetUserInfoSelfResponses, UserServiceGetUserInfoSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/info:self',
    ...options
});

export const userServiceUpdateUserInfoSelf = <ThrowOnError extends boolean = false>(options: Options<UserServiceUpdateUserInfoSelfData, ThrowOnError>) => (options.client ?? client).patch<UserServiceUpdateUserInfoSelfResponses, UserServiceUpdateUserInfoSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/info:self',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceUpdatePassword = <ThrowOnError extends boolean = false>(options: Options<UserServiceUpdatePasswordData, ThrowOnError>) => (options.client ?? client).patch<UserServiceUpdatePasswordResponses, UserServiceUpdatePasswordErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceCheckPasswordCode = <ThrowOnError extends boolean = false>(options: Options<UserServiceCheckPasswordCodeData, ThrowOnError>) => (options.client ?? client).get<UserServiceCheckPasswordCodeResponses, UserServiceCheckPasswordCodeErrors, ThrowOnError>({ url: '/users/password/{code}', ...options });

export const userServiceActivatePasswordCode = <ThrowOnError extends boolean = false>(options: Options<UserServiceActivatePasswordCodeData, ThrowOnError>) => (options.client ?? client).patch<UserServiceActivatePasswordCodeResponses, UserServiceActivatePasswordCodeErrors, ThrowOnError>({
    url: '/users/password/{code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceResetPassword = <ThrowOnError extends boolean = false>(options: Options<UserServiceResetPasswordData, ThrowOnError>) => (options.client ?? client).post<UserServiceResetPasswordResponses, UserServiceResetPasswordErrors, ThrowOnError>({
    url: '/users/password:reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceSetUserRank = <ThrowOnError extends boolean = false>(options: Options<UserServiceSetUserRankData, ThrowOnError>) => (options.client ?? client).post<UserServiceSetUserRankResponses, UserServiceSetUserRankErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/rank:self',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceUpdateUsername = <ThrowOnError extends boolean = false>(options: Options<UserServiceUpdateUsernameData, ThrowOnError>) => (options.client ?? client).patch<UserServiceUpdateUsernameResponses, UserServiceUpdateUsernameErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/username',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const userServiceListUserLoginDetails = <ThrowOnError extends boolean = false>(options: Options<UserServiceListUserLoginDetailsData, ThrowOnError>) => (options.client ?? client).get<UserServiceListUserLoginDetailsResponses, UserServiceListUserLoginDetailsErrors, ThrowOnError>({ url: '/users/{identity}:login', ...options });

export const userServiceDeleteUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceDeleteUserData, ThrowOnError>) => (options.client ?? client).delete<UserServiceDeleteUserResponses, UserServiceDeleteUserErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options
});

export const userServiceGetUser = <ThrowOnError extends boolean = false>(options: Options<UserServiceGetUserData, ThrowOnError>) => (options.client ?? client).get<UserServiceGetUserResponses, UserServiceGetUserErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users/{id}',
    ...options
});

export const userServiceGetUserPlayer = <ThrowOnError extends boolean = false>(options: Options<UserServiceGetUserPlayerData, ThrowOnError>) => (options.client ?? client).get<UserServiceGetUserPlayerResponses, UserServiceGetUserPlayerErrors, ThrowOnError>({ url: '/users/{id}:player', ...options });

export const userServiceListUsersRoles = <ThrowOnError extends boolean = false>(options?: Options<UserServiceListUsersRolesData, ThrowOnError>) => (options?.client ?? client).get<UserServiceListUsersRolesResponses, UserServiceListUsersRolesErrors, ThrowOnError>({ url: '/users:roles', ...options });

export const userServiceDeleteUserSelf = <ThrowOnError extends boolean = false>(options?: Options<UserServiceDeleteUserSelfData, ThrowOnError>) => (options?.client ?? client).delete<UserServiceDeleteUserSelfResponses, UserServiceDeleteUserSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users:self',
    ...options
});

export const userServiceGetUserSelf = <ThrowOnError extends boolean = false>(options?: Options<UserServiceGetUserSelfData, ThrowOnError>) => (options?.client ?? client).get<UserServiceGetUserSelfResponses, UserServiceGetUserSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/users:self',
    ...options
});

export const articleServiceListArticles = <ThrowOnError extends boolean = false>(options?: Options<ArticleServiceListArticlesData, ThrowOnError>) => (options?.client ?? client).get<ArticleServiceListArticlesResponses, ArticleServiceListArticlesErrors, ThrowOnError>({ url: '/articles', ...options });

export const articleServiceCreateArticle = <ThrowOnError extends boolean = false>(options: Options<ArticleServiceCreateArticleData, ThrowOnError>) => (options.client ?? client).post<ArticleServiceCreateArticleResponses, ArticleServiceCreateArticleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/articles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const articleServiceGetArticleTags = <ThrowOnError extends boolean = false>(options?: Options<ArticleServiceGetArticleTagsData, ThrowOnError>) => (options?.client ?? client).get<ArticleServiceGetArticleTagsResponses, ArticleServiceGetArticleTagsErrors, ThrowOnError>({ url: '/articles/tags', ...options });

export const articleServiceDeleteArticle = <ThrowOnError extends boolean = false>(options: Options<ArticleServiceDeleteArticleData, ThrowOnError>) => (options.client ?? client).delete<ArticleServiceDeleteArticleResponses, ArticleServiceDeleteArticleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/articles/{id}',
    ...options
});

export const articleServiceGetArticle = <ThrowOnError extends boolean = false>(options: Options<ArticleServiceGetArticleData, ThrowOnError>) => (options.client ?? client).get<ArticleServiceGetArticleResponses, ArticleServiceGetArticleErrors, ThrowOnError>({ url: '/articles/{id}', ...options });

export const articleServiceUpdateArticle = <ThrowOnError extends boolean = false>(options: Options<ArticleServiceUpdateArticleData, ThrowOnError>) => (options.client ?? client).patch<ArticleServiceUpdateArticleResponses, ArticleServiceUpdateArticleErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/articles/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const articleServiceGetReactions = <ThrowOnError extends boolean = false>(options: Options<ArticleServiceGetReactionsData, ThrowOnError>) => (options.client ?? client).get<ArticleServiceGetReactionsResponses, ArticleServiceGetReactionsErrors, ThrowOnError>({ url: '/articles/{id}/reactions', ...options });

export const articleServicePostReaction = <ThrowOnError extends boolean = false>(options: Options<ArticleServicePostReactionData, ThrowOnError>) => (options.client ?? client).post<ArticleServicePostReactionResponses, ArticleServicePostReactionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/articles/{id}/reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceListPolls = <ThrowOnError extends boolean = false>(options?: Options<PollServiceListPollsData, ThrowOnError>) => (options?.client ?? client).get<PollServiceListPollsResponses, PollServiceListPollsErrors, ThrowOnError>({ url: '/polls', ...options });

export const pollServiceCreatePoll = <ThrowOnError extends boolean = false>(options: Options<PollServiceCreatePollData, ThrowOnError>) => (options.client ?? client).post<PollServiceCreatePollResponses, PollServiceCreatePollErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceDeletePoll = <ThrowOnError extends boolean = false>(options: Options<PollServiceDeletePollData, ThrowOnError>) => (options.client ?? client).delete<PollServiceDeletePollResponses, PollServiceDeletePollErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{id}',
    ...options
});

export const pollServiceGetPoll = <ThrowOnError extends boolean = false>(options: Options<PollServiceGetPollData, ThrowOnError>) => (options.client ?? client).get<PollServiceGetPollResponses, PollServiceGetPollErrors, ThrowOnError>({ url: '/polls/{id}', ...options });

export const pollServiceUpdatePoll = <ThrowOnError extends boolean = false>(options: Options<PollServiceUpdatePollData, ThrowOnError>) => (options.client ?? client).patch<PollServiceUpdatePollResponses, PollServiceUpdatePollErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceCastPollVotes = <ThrowOnError extends boolean = false>(options: Options<PollServiceCastPollVotesData, ThrowOnError>) => (options.client ?? client).put<PollServiceCastPollVotesResponses, PollServiceCastPollVotesErrors, ThrowOnError>({
    url: '/polls/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceOrderPollOptions = <ThrowOnError extends boolean = false>(options: Options<PollServiceOrderPollOptionsData, ThrowOnError>) => (options.client ?? client).patch<PollServiceOrderPollOptionsResponses, PollServiceOrderPollOptionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{pollId}/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceAddPollOptions = <ThrowOnError extends boolean = false>(options: Options<PollServiceAddPollOptionsData, ThrowOnError>) => (options.client ?? client).post<PollServiceAddPollOptionsResponses, PollServiceAddPollOptionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{pollId}/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollServiceDeletePollOption = <ThrowOnError extends boolean = false>(options: Options<PollServiceDeletePollOptionData, ThrowOnError>) => (options.client ?? client).delete<PollServiceDeletePollOptionResponses, PollServiceDeletePollOptionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{pollId}/options/{optionId}',
    ...options
});

export const pollServiceUpdatePollOption = <ThrowOnError extends boolean = false>(options: Options<PollServiceUpdatePollOptionData, ThrowOnError>) => (options.client ?? client).patch<PollServiceUpdatePollOptionResponses, PollServiceUpdatePollOptionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/polls/{pollId}/options/{optionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const tournamentServiceAdminTournamentIgnore = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceAdminTournamentIgnoreData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceAdminTournamentIgnoreResponses, TournamentServiceAdminTournamentIgnoreErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tournaments/ignore/{id}',
    ...options
});

export const tournamentServiceAdminTournamentsLocations = <ThrowOnError extends boolean = false>(options?: Options<TournamentServiceAdminTournamentsLocationsData, ThrowOnError>) => (options?.client ?? client).get<TournamentServiceAdminTournamentsLocationsResponses, TournamentServiceAdminTournamentsLocationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tournaments/locations',
    ...options
});

export const tournamentServiceAdminTournamentPin = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceAdminTournamentPinData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceAdminTournamentPinResponses, TournamentServiceAdminTournamentPinErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tournaments/pin/{id}',
    ...options
});

export const tournamentServiceAdminTournamentProcess = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceAdminTournamentProcessData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceAdminTournamentProcessResponses, TournamentServiceAdminTournamentProcessErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tournaments/process/{id}',
    ...options
});

export const tournamentServiceAdminTournamentLocation = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceAdminTournamentLocationData, ThrowOnError>) => (options.client ?? client).patch<TournamentServiceAdminTournamentLocationResponses, TournamentServiceAdminTournamentLocationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/tournaments/{id}/location/{location}',
    ...options
});

export const tournamentServiceListTournaments = <ThrowOnError extends boolean = false>(options?: Options<TournamentServiceListTournamentsData, ThrowOnError>) => (options?.client ?? client).get<TournamentServiceListTournamentsResponses, TournamentServiceListTournamentsErrors, ThrowOnError>({ url: '/tournaments', ...options });

export const tournamentServiceGetTournament = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceGetTournamentData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceGetTournamentResponses, TournamentServiceGetTournamentErrors, ThrowOnError>({ url: '/tournaments/{id}', ...options });

export const tournamentServiceListTournamentGames = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceListTournamentGamesData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceListTournamentGamesResponses, TournamentServiceListTournamentGamesErrors, ThrowOnError>({ url: '/tournaments/{id}/games', ...options });

export const tournamentServiceGetTournamentStatistics = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceGetTournamentStatisticsData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceGetTournamentStatisticsResponses, TournamentServiceGetTournamentStatisticsErrors, ThrowOnError>({ url: '/tournaments/{id}/statistics', ...options });

export const tournamentServiceGetTournamentPerformance = <ThrowOnError extends boolean = false>(options: Options<TournamentServiceGetTournamentPerformanceData, ThrowOnError>) => (options.client ?? client).get<TournamentServiceGetTournamentPerformanceResponses, TournamentServiceGetTournamentPerformanceErrors, ThrowOnError>({ url: '/tournaments/{tid}/performance/{pid}', ...options });

export const tournamentServiceListTournamentsLocations = <ThrowOnError extends boolean = false>(options?: Options<TournamentServiceListTournamentsLocationsData, ThrowOnError>) => (options?.client ?? client).get<TournamentServiceListTournamentsLocationsResponses, TournamentServiceListTournamentsLocationsErrors, ThrowOnError>({ url: '/tournaments:locations', ...options });

export const tournamentServiceGetTournamentsStatistics = <ThrowOnError extends boolean = false>(options?: Options<TournamentServiceGetTournamentsStatisticsData, ThrowOnError>) => (options?.client ?? client).get<TournamentServiceGetTournamentsStatisticsResponses, TournamentServiceGetTournamentsStatisticsErrors, ThrowOnError>({ url: '/tournaments:statistics', ...options });

export const broadcastServiceListBroadcasts = <ThrowOnError extends boolean = false>(options?: Options<BroadcastServiceListBroadcastsData, ThrowOnError>) => (options?.client ?? client).get<BroadcastServiceListBroadcastsResponses, BroadcastServiceListBroadcastsErrors, ThrowOnError>({ url: '/broadcasts', ...options });

export const broadcastServicePostBroadcast = <ThrowOnError extends boolean = false>(options: Options<BroadcastServicePostBroadcastData, ThrowOnError>) => (options.client ?? client).post<BroadcastServicePostBroadcastResponses, BroadcastServicePostBroadcastErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcasts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const broadcastServiceBroadcastAccess = <ThrowOnError extends boolean = false>(options: Options<BroadcastServiceBroadcastAccessData, ThrowOnError>) => (options.client ?? client).patch<BroadcastServiceBroadcastAccessResponses, BroadcastServiceBroadcastAccessErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcasts/{bid}/users/{userId}:access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const broadcastServiceDeleteBroadcast = <ThrowOnError extends boolean = false>(options: Options<BroadcastServiceDeleteBroadcastData, ThrowOnError>) => (options.client ?? client).delete<BroadcastServiceDeleteBroadcastResponses, BroadcastServiceDeleteBroadcastErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcasts/{id}',
    ...options
});

export const broadcastServiceGetBroadcast = <ThrowOnError extends boolean = false>(options: Options<BroadcastServiceGetBroadcastData, ThrowOnError>) => (options.client ?? client).get<BroadcastServiceGetBroadcastResponses, BroadcastServiceGetBroadcastErrors, ThrowOnError>({ url: '/broadcasts/{id}', ...options });

export const broadcastServiceUpdateBroadcast = <ThrowOnError extends boolean = false>(options: Options<BroadcastServiceUpdateBroadcastData, ThrowOnError>) => (options.client ?? client).patch<BroadcastServiceUpdateBroadcastResponses, BroadcastServiceUpdateBroadcastErrors, ThrowOnError>({
    url: '/broadcasts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const broadcastServiceGetCommunicationToken = <ThrowOnError extends boolean = false>(options: Options<BroadcastServiceGetCommunicationTokenData, ThrowOnError>) => (options.client ?? client).get<BroadcastServiceGetCommunicationTokenResponses, BroadcastServiceGetCommunicationTokenErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcasts/{id}:connect',
    ...options
});

export const studyServiceListCoaches = <ThrowOnError extends boolean = false>(options?: Options<StudyServiceListCoachesData, ThrowOnError>) => (options?.client ?? client).get<StudyServiceListCoachesResponses, StudyServiceListCoachesErrors, ThrowOnError>({ url: '/coaches', ...options });

export const studyServiceCreateCoach = <ThrowOnError extends boolean = false>(options: Options<StudyServiceCreateCoachData, ThrowOnError>) => (options.client ?? client).post<StudyServiceCreateCoachResponses, StudyServiceCreateCoachErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/coaches',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const studyServiceDeleteCoach = <ThrowOnError extends boolean = false>(options: Options<StudyServiceDeleteCoachData, ThrowOnError>) => (options.client ?? client).delete<StudyServiceDeleteCoachResponses, StudyServiceDeleteCoachErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/coaches/{id}',
    ...options
});

export const studyServiceGetCoach = <ThrowOnError extends boolean = false>(options: Options<StudyServiceGetCoachData, ThrowOnError>) => (options.client ?? client).get<StudyServiceGetCoachResponses, StudyServiceGetCoachErrors, ThrowOnError>({ url: '/coaches/{id}', ...options });

export const studyServiceUpdateCoach = <ThrowOnError extends boolean = false>(options: Options<StudyServiceUpdateCoachData, ThrowOnError>) => (options.client ?? client).patch<StudyServiceUpdateCoachResponses, StudyServiceUpdateCoachErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/coaches/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const studyServiceListProducts = <ThrowOnError extends boolean = false>(options?: Options<StudyServiceListProductsData, ThrowOnError>) => (options?.client ?? client).get<StudyServiceListProductsResponses, StudyServiceListProductsErrors, ThrowOnError>({ url: '/products', ...options });

export const studyServiceCreateProduct = <ThrowOnError extends boolean = false>(options: Options<StudyServiceCreateProductData, ThrowOnError>) => (options.client ?? client).post<StudyServiceCreateProductResponses, StudyServiceCreateProductErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const studyServiceRemoveParticipant = <ThrowOnError extends boolean = false>(options: Options<StudyServiceRemoveParticipantData, ThrowOnError>) => (options.client ?? client).delete<StudyServiceRemoveParticipantResponses, StudyServiceRemoveParticipantErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/products/participants/{id}',
    ...options
});

export const studyServiceDeleteProduct = <ThrowOnError extends boolean = false>(options: Options<StudyServiceDeleteProductData, ThrowOnError>) => (options.client ?? client).delete<StudyServiceDeleteProductResponses, StudyServiceDeleteProductErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/products/{id}',
    ...options
});

export const studyServiceGetProduct = <ThrowOnError extends boolean = false>(options: Options<StudyServiceGetProductData, ThrowOnError>) => (options.client ?? client).get<StudyServiceGetProductResponses, StudyServiceGetProductErrors, ThrowOnError>({ url: '/products/{id}', ...options });

export const studyServiceUpdateProduct = <ThrowOnError extends boolean = false>(options: Options<StudyServiceUpdateProductData, ThrowOnError>) => (options.client ?? client).patch<StudyServiceUpdateProductResponses, StudyServiceUpdateProductErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const studyServiceApplyParticipant = <ThrowOnError extends boolean = false>(options: Options<StudyServiceApplyParticipantData, ThrowOnError>) => (options.client ?? client).post<StudyServiceApplyParticipantResponses, StudyServiceApplyParticipantErrors, ThrowOnError>({
    url: '/products/{id}/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const clubServiceListClubs = <ThrowOnError extends boolean = false>(options?: Options<ClubServiceListClubsData, ThrowOnError>) => (options?.client ?? client).get<ClubServiceListClubsResponses, ClubServiceListClubsErrors, ThrowOnError>({ url: '/clubs', ...options });

export const clubServiceCreateClub = <ThrowOnError extends boolean = false>(options: Options<ClubServiceCreateClubData, ThrowOnError>) => (options.client ?? client).post<ClubServiceCreateClubResponses, ClubServiceCreateClubErrors, ThrowOnError>({
    url: '/clubs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const clubServiceGetClubVoucherInfo = <ThrowOnError extends boolean = false>(options: Options<ClubServiceGetClubVoucherInfoData, ThrowOnError>) => (options.client ?? client).get<ClubServiceGetClubVoucherInfoResponses, ClubServiceGetClubVoucherInfoErrors, ThrowOnError>({ url: '/clubs/vouchers/{code}', ...options });

export const clubServiceRedeemClubVoucher = <ThrowOnError extends boolean = false>(options: Options<ClubServiceRedeemClubVoucherData, ThrowOnError>) => (options.client ?? client).patch<ClubServiceRedeemClubVoucherResponses, ClubServiceRedeemClubVoucherErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/clubs/vouchers/{code}:redeem',
    ...options
});

export const clubServiceGetClub = <ThrowOnError extends boolean = false>(options: Options<ClubServiceGetClubData, ThrowOnError>) => (options.client ?? client).get<ClubServiceGetClubResponses, ClubServiceGetClubErrors, ThrowOnError>({ url: '/clubs/{id}', ...options });

export const paymentServiceGetDonationsInfo = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceGetDonationsInfoData, ThrowOnError>) => (options?.client ?? client).get<PaymentServiceGetDonationsInfoResponses, PaymentServiceGetDonationsInfoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/donations',
    ...options
});

export const paymentServiceListDonations = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListDonationsData, ThrowOnError>) => (options?.client ?? client).get<PaymentServiceListDonationsResponses, PaymentServiceListDonationsErrors, ThrowOnError>({ url: '/donations', ...options });

export const paymentServiceListDonationVotes = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceListDonationVotesData, ThrowOnError>) => (options?.client ?? client).get<PaymentServiceListDonationVotesResponses, PaymentServiceListDonationVotesErrors, ThrowOnError>({ url: '/donations/votes', ...options });

export const paymentServiceCastDonationVotes = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceCastDonationVotesData, ThrowOnError>) => (options.client ?? client).post<PaymentServiceCastDonationVotesResponses, PaymentServiceCastDonationVotesErrors, ThrowOnError>({
    url: '/donations/votes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const paymentServiceGetDonation = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetDonationData, ThrowOnError>) => (options.client ?? client).get<PaymentServiceGetDonationResponses, PaymentServiceGetDonationErrors, ThrowOnError>({ url: '/donations/{id}', ...options });

export const paymentServiceGetDonationsSelf = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceGetDonationsSelfData, ThrowOnError>) => (options?.client ?? client).get<PaymentServiceGetDonationsSelfResponses, PaymentServiceGetDonationsSelfErrors, ThrowOnError>({ url: '/donations:self', ...options });

export const paymentServiceGetDonationsTotals = <ThrowOnError extends boolean = false>(options?: Options<PaymentServiceGetDonationsTotalsData, ThrowOnError>) => (options?.client ?? client).get<PaymentServiceGetDonationsTotalsResponses, PaymentServiceGetDonationsTotalsErrors, ThrowOnError>({ url: '/donations:total', ...options });

export const paymentServiceCreatePayment = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceCreatePaymentData, ThrowOnError>) => (options.client ?? client).post<PaymentServiceCreatePaymentResponses, PaymentServiceCreatePaymentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const paymentServiceGetVoucherInfo = <ThrowOnError extends boolean = false>(options: Options<PaymentServiceGetVoucherInfoData, ThrowOnError>) => (options.client ?? client).get<PaymentServiceGetVoucherInfoResponses, PaymentServiceGetVoucherInfoErrors, ThrowOnError>({ url: '/vouchers/{code}', ...options });

export const refereeServiceListTournaments = <ThrowOnError extends boolean = false>(options?: Options<RefereeServiceListTournamentsData, ThrowOnError>) => (options?.client ?? client).get<RefereeServiceListTournamentsResponses, RefereeServiceListTournamentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee',
    ...options
});

export const refereeServiceCreateTournament = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceCreateTournamentData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceCreateTournamentResponses, RefereeServiceCreateTournamentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceRegistrationFormFields = <ThrowOnError extends boolean = false>(options?: Options<RefereeServiceRegistrationFormFieldsData, ThrowOnError>) => (options?.client ?? client).get<RefereeServiceRegistrationFormFieldsResponses, RefereeServiceRegistrationFormFieldsErrors, ThrowOnError>({ url: '/referee/form/fields', ...options });

/**
 * Temporary
 */
export const refereeServiceSeedGroupsTest = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceSeedGroupsTestData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceSeedGroupsTestResponses, RefereeServiceSeedGroupsTestErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/seed/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceSeedRoundsTest = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceSeedRoundsTestData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceSeedRoundsTestResponses, RefereeServiceSeedRoundsTestErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/seed/rounds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceDeleteTournament = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceDeleteTournamentData, ThrowOnError>) => (options.client ?? client).delete<RefereeServiceDeleteTournamentResponses, RefereeServiceDeleteTournamentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}',
    ...options
});

export const refereeServiceGetTournament = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceGetTournamentData, ThrowOnError>) => (options.client ?? client).get<RefereeServiceGetTournamentResponses, RefereeServiceGetTournamentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}',
    ...options
});

export const refereeServiceUpdateTournament = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdateTournamentData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdateTournamentResponses, RefereeServiceUpdateTournamentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceUpdateRegistrationForm = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdateRegistrationFormData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdateRegistrationFormResponses, RefereeServiceUpdateRegistrationFormErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/form',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceListParticipants = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceListParticipantsData, ThrowOnError>) => (options.client ?? client).get<RefereeServiceListParticipantsResponses, RefereeServiceListParticipantsErrors, ThrowOnError>({ url: '/referee/{id}/participants', ...options });

export const refereeServiceCreateParticipant = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceCreateParticipantData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceCreateParticipantResponses, RefereeServiceCreateParticipantErrors, ThrowOnError>({
    url: '/referee/{id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceUpdateParticipant = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdateParticipantData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdateParticipantResponses, RefereeServiceUpdateParticipantErrors, ThrowOnError>({
    url: '/referee/{id}/participants/{participantId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceAddTournamentPersonnel = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceAddTournamentPersonnelData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceAddTournamentPersonnelResponses, RefereeServiceAddTournamentPersonnelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/personnel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceDeletePersonnel = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceDeletePersonnelData, ThrowOnError>) => (options.client ?? client).delete<RefereeServiceDeletePersonnelResponses, RefereeServiceDeletePersonnelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/personnel/{personnelId}',
    ...options
});

export const refereeServiceUpdatePersonnel = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdatePersonnelData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdatePersonnelResponses, RefereeServiceUpdatePersonnelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/personnel/{personnelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceUpdatePrizeInfo = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdatePrizeInfoData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdatePrizeInfoResponses, RefereeServiceUpdatePrizeInfoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/prize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceAddTournamentStage = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceAddTournamentStageData, ThrowOnError>) => (options.client ?? client).post<RefereeServiceAddTournamentStageResponses, RefereeServiceAddTournamentStageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/stages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const refereeServiceDeleteStage = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceDeleteStageData, ThrowOnError>) => (options.client ?? client).delete<RefereeServiceDeleteStageResponses, RefereeServiceDeleteStageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/stages/{stageId}',
    ...options
});

export const refereeServiceUpdateStage = <ThrowOnError extends boolean = false>(options: Options<RefereeServiceUpdateStageData, ThrowOnError>) => (options.client ?? client).patch<RefereeServiceUpdateStageResponses, RefereeServiceUpdateStageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/referee/{id}/stages/{stageId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const gameServiceListChallenges = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListChallengesData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListChallengesResponses, GameServiceListChallengesErrors, ThrowOnError>({ url: '/challenges', ...options });

export const gameServicePostChallenge = <ThrowOnError extends boolean = false>(options: Options<GameServicePostChallengeData, ThrowOnError>) => (options.client ?? client).post<GameServicePostChallengeResponses, GameServicePostChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/challenges',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const gameServiceStreamChallenges = <ThrowOnError extends boolean = false>(options?: Options<GameServiceStreamChallengesData, ThrowOnError>) => (options?.client ?? client).get<GameServiceStreamChallengesResponses, GameServiceStreamChallengesErrors, ThrowOnError>({ url: '/challenges/stream', ...options });

export const gameServiceCancelChallenge = <ThrowOnError extends boolean = false>(options: Options<GameServiceCancelChallengeData, ThrowOnError>) => (options.client ?? client).delete<GameServiceCancelChallengeResponses, GameServiceCancelChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/challenges/{id}',
    ...options
});

export const gameServiceGetChallenge = <ThrowOnError extends boolean = false>(options: Options<GameServiceGetChallengeData, ThrowOnError>) => (options.client ?? client).get<GameServiceGetChallengeResponses, GameServiceGetChallengeErrors, ThrowOnError>({ url: '/challenges/{id}', ...options });

export const gameServiceAcceptChallenge = <ThrowOnError extends boolean = false>(options: Options<GameServiceAcceptChallengeData, ThrowOnError>) => (options.client ?? client).post<GameServiceAcceptChallengeResponses, GameServiceAcceptChallengeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/challenges/{id}',
    ...options
});

export const gameServiceListChallengesSelf = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListChallengesSelfData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListChallengesSelfResponses, GameServiceListChallengesSelfErrors, ThrowOnError>({ url: '/challenges:self', ...options });

export const gameServiceListGames = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListGamesData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListGamesResponses, GameServiceListGamesErrors, ThrowOnError>({ url: '/games', ...options });

export const gameServiceListGamesCurrent = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListGamesCurrentData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListGamesCurrentResponses, GameServiceListGamesCurrentErrors, ThrowOnError>({ url: '/games:current', ...options });

export const gameServiceListGamesSelf = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListGamesSelfData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListGamesSelfResponses, GameServiceListGamesSelfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/games:self',
    ...options
});

export const gameServiceListChatRooms = <ThrowOnError extends boolean = false>(options?: Options<GameServiceListChatRoomsData, ThrowOnError>) => (options?.client ?? client).get<GameServiceListChatRoomsResponses, GameServiceListChatRoomsErrors, ThrowOnError>({ url: '/server/chat', ...options });

export const logServicePostLog = <ThrowOnError extends boolean = false>(options: Options<LogServicePostLogData, ThrowOnError>) => (options.client ?? client).post<LogServicePostLogResponses, LogServicePostLogErrors, ThrowOnError>({
    url: '/logs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const logServiceListNotifications = <ThrowOnError extends boolean = false>(options?: Options<LogServiceListNotificationsData, ThrowOnError>) => (options?.client ?? client).get<LogServiceListNotificationsResponses, LogServiceListNotificationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notify',
    ...options
});

export const logServiceStreamNotifications = <ThrowOnError extends boolean = false>(options?: Options<LogServiceStreamNotificationsData, ThrowOnError>) => (options?.client ?? client).get<LogServiceStreamNotificationsResponses, LogServiceStreamNotificationsErrors, ThrowOnError>({ url: '/notify/stream', ...options });

export const logServiceDeleteNotify = <ThrowOnError extends boolean = false>(options: Options<LogServiceDeleteNotifyData, ThrowOnError>) => (options.client ?? client).delete<LogServiceDeleteNotifyResponses, LogServiceDeleteNotifyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notify/{id}',
    ...options
});

export const logServiceReadNotify = <ThrowOnError extends boolean = false>(options: Options<LogServiceReadNotifyData, ThrowOnError>) => (options.client ?? client).patch<LogServiceReadNotifyResponses, LogServiceReadNotifyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/notify/{id}',
    ...options
});

export const serverServiceBroadcastBack = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastBackData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastBackResponses, ServerServiceBroadcastBackErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/back',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastChat = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastChatData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastChatResponses, ServerServiceBroadcastChatErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastCut = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastCutData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastCutResponses, ServerServiceBroadcastCutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/cut',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastMove = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastMoveData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastMoveResponses, ServerServiceBroadcastMoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/move/{move}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastPass = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastPassData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastPassResponses, ServerServiceBroadcastPassErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/pass/{color}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastPrune = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastPruneData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastPruneResponses, ServerServiceBroadcastPruneErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/prune',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastResult = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastResultData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastResultResponses, ServerServiceBroadcastResultErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastSetCurrentNode = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastSetCurrentNodeData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastSetCurrentNodeResponses, ServerServiceBroadcastSetCurrentNodeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/set_current_node/{nodeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastSetNodeMetadata = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastSetNodeMetadataData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastSetNodeMetadataResponses, ServerServiceBroadcastSetNodeMetadataErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/set_node_metadata/{nodeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastSgf = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastSgfData, ThrowOnError>) => (options.client ?? client).get<ServerServiceBroadcastSgfResponses, ServerServiceBroadcastSgfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/sgf',
    ...options
});

export const serverServiceBroadcastUploadSgf = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastUploadSgfData, ThrowOnError>) => (options.client ?? client).patch<ServerServiceBroadcastUploadSgfResponses, ServerServiceBroadcastUploadSgfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/sgf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceBroadcastUndo = <ThrowOnError extends boolean = false>(options: Options<ServerServiceBroadcastUndoData, ThrowOnError>) => (options.client ?? client).post<ServerServiceBroadcastUndoResponses, ServerServiceBroadcastUndoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/broadcast/{id}/undo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceAcceptDeadStones = <ThrowOnError extends boolean = false>(options: Options<ServerServiceAcceptDeadStonesData, ThrowOnError>) => (options.client ?? client).post<ServerServiceAcceptDeadStonesResponses, ServerServiceAcceptDeadStonesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/accept_dead_stones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceAcceptUndo = <ThrowOnError extends boolean = false>(options: Options<ServerServiceAcceptUndoData, ThrowOnError>) => (options.client ?? client).post<ServerServiceAcceptUndoResponses, ServerServiceAcceptUndoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/accept_undo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceAiReferee = <ThrowOnError extends boolean = false>(options: Options<ServerServiceAiRefereeData, ThrowOnError>) => (options.client ?? client).post<ServerServiceAiRefereeResponses, ServerServiceAiRefereeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/ai_referee',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceGameChat = <ThrowOnError extends boolean = false>(options: Options<ServerServiceGameChatData, ThrowOnError>) => (options.client ?? client).post<ServerServiceGameChatResponses, ServerServiceGameChatErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceGameMove = <ThrowOnError extends boolean = false>(options: Options<ServerServiceGameMoveData, ThrowOnError>) => (options.client ?? client).post<ServerServiceGameMoveResponses, ServerServiceGameMoveErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/move/{move}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceGamePass = <ThrowOnError extends boolean = false>(options: Options<ServerServiceGamePassData, ThrowOnError>) => (options.client ?? client).post<ServerServiceGamePassResponses, ServerServiceGamePassErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/pass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceRejectDeadStones = <ThrowOnError extends boolean = false>(options: Options<ServerServiceRejectDeadStonesData, ThrowOnError>) => (options.client ?? client).post<ServerServiceRejectDeadStonesResponses, ServerServiceRejectDeadStonesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/reject_dead_stones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceRejectUndo = <ThrowOnError extends boolean = false>(options: Options<ServerServiceRejectUndoData, ThrowOnError>) => (options.client ?? client).post<ServerServiceRejectUndoResponses, ServerServiceRejectUndoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/reject_undo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceRequestUndo = <ThrowOnError extends boolean = false>(options: Options<ServerServiceRequestUndoData, ThrowOnError>) => (options.client ?? client).post<ServerServiceRequestUndoResponses, ServerServiceRequestUndoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/request_undo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceGameResign = <ThrowOnError extends boolean = false>(options: Options<ServerServiceGameResignData, ThrowOnError>) => (options.client ?? client).post<ServerServiceGameResignResponses, ServerServiceGameResignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/resign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceGameSgf = <ThrowOnError extends boolean = false>(options: Options<ServerServiceGameSgfData, ThrowOnError>) => (options.client ?? client).get<ServerServiceGameSgfResponses, ServerServiceGameSgfErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/sgf',
    ...options
});

export const serverServiceToggleDeadStones = <ThrowOnError extends boolean = false>(options: Options<ServerServiceToggleDeadStonesData, ThrowOnError>) => (options.client ?? client).post<ServerServiceToggleDeadStonesResponses, ServerServiceToggleDeadStonesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/game/{id}/toggle_dead_stones/{move}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const serverServiceStreamBroadcast = <ThrowOnError extends boolean = false>(options: Options<ServerServiceStreamBroadcastData, ThrowOnError>) => (options.client ?? client).get<ServerServiceStreamBroadcastResponses, ServerServiceStreamBroadcastErrors, ThrowOnError>({ url: '/stream/broadcast/{id}', ...options });

export const serverServiceStreamGame = <ThrowOnError extends boolean = false>(options: Options<ServerServiceStreamGameData, ThrowOnError>) => (options.client ?? client).get<ServerServiceStreamGameResponses, ServerServiceStreamGameErrors, ThrowOnError>({ url: '/stream/game/{id}', ...options });

export const ratingServiceListRatingHistory = <ThrowOnError extends boolean = false>(options: Options<RatingServiceListRatingHistoryData, ThrowOnError>) => (options.client ?? client).get<RatingServiceListRatingHistoryResponses, RatingServiceListRatingHistoryErrors, ThrowOnError>({ url: '/rating/{id}', ...options });

export const ratingServiceGetForm = <ThrowOnError extends boolean = false>(options: Options<RatingServiceGetFormData, ThrowOnError>) => (options.client ?? client).get<RatingServiceGetFormResponses, RatingServiceGetFormErrors, ThrowOnError>({ url: '/rating/{id}/form', ...options });

export const chatServiceAdminSetArchiveRoom = <ThrowOnError extends boolean = false>(options: Options<ChatServiceAdminSetArchiveRoomData, ThrowOnError>) => (options.client ?? client).patch<ChatServiceAdminSetArchiveRoomResponses, ChatServiceAdminSetArchiveRoomErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/chat/rooms/{rid}:archive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceAdminCreateSpace = <ThrowOnError extends boolean = false>(options: Options<ChatServiceAdminCreateSpaceData, ThrowOnError>) => (options.client ?? client).post<ChatServiceAdminCreateSpaceResponses, ChatServiceAdminCreateSpaceErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/chat/spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceAdminCreateRoom = <ThrowOnError extends boolean = false>(options: Options<ChatServiceAdminCreateRoomData, ThrowOnError>) => (options.client ?? client).post<ChatServiceAdminCreateRoomResponses, ChatServiceAdminCreateRoomErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/admin/chat/spaces/{sid}/rooms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceListRoomMembers = <ThrowOnError extends boolean = false>(options: Options<ChatServiceListRoomMembersData, ThrowOnError>) => (options.client ?? client).get<ChatServiceListRoomMembersResponses, ChatServiceListRoomMembersErrors, ThrowOnError>({ url: '/chat/rooms/{rid}/members', ...options });

export const chatServiceAdminSetBanRoomMember = <ThrowOnError extends boolean = false>(options: Options<ChatServiceAdminSetBanRoomMemberData, ThrowOnError>) => (options.client ?? client).patch<ChatServiceAdminSetBanRoomMemberResponses, ChatServiceAdminSetBanRoomMemberErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/chat/rooms/{rid}/members/{userId}:ban',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceListRoomMessages = <ThrowOnError extends boolean = false>(options: Options<ChatServiceListRoomMessagesData, ThrowOnError>) => (options.client ?? client).get<ChatServiceListRoomMessagesResponses, ChatServiceListRoomMessagesErrors, ThrowOnError>({ url: '/chat/rooms/{rid}/messages', ...options });

export const chatServiceSendRoomMessage = <ThrowOnError extends boolean = false>(options: Options<ChatServiceSendRoomMessageData, ThrowOnError>) => (options.client ?? client).post<ChatServiceSendRoomMessageResponses, ChatServiceSendRoomMessageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/chat/rooms/{rid}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceSendRoomMessageReaction = <ThrowOnError extends boolean = false>(options: Options<ChatServiceSendRoomMessageReactionData, ThrowOnError>) => (options.client ?? client).put<ChatServiceSendRoomMessageReactionResponses, ChatServiceSendRoomMessageReactionErrors, ThrowOnError>({
    url: '/chat/rooms/{rid}/messages/{eventId}/reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceAdminRedactRoomMessage = <ThrowOnError extends boolean = false>(options: Options<ChatServiceAdminRedactRoomMessageData, ThrowOnError>) => (options.client ?? client).patch<ChatServiceAdminRedactRoomMessageResponses, ChatServiceAdminRedactRoomMessageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/chat/rooms/{rid}/messages/{eventId}:redact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const chatServiceStreamRoomEvents = <ThrowOnError extends boolean = false>(options: Options<ChatServiceStreamRoomEventsData, ThrowOnError>) => (options.client ?? client).get<ChatServiceStreamRoomEventsResponses, ChatServiceStreamRoomEventsErrors, ThrowOnError>({ url: '/chat/rooms/{rid}/stream', ...options });

export const chatServiceAdminListSpaces = <ThrowOnError extends boolean = false>(options?: Options<ChatServiceAdminListSpacesData, ThrowOnError>) => (options?.client ?? client).get<ChatServiceAdminListSpacesResponses, ChatServiceAdminListSpacesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/chat/spaces',
    ...options
});

export const chatServiceListSpaceRooms = <ThrowOnError extends boolean = false>(options: Options<ChatServiceListSpaceRoomsData, ThrowOnError>) => (options.client ?? client).get<ChatServiceListSpaceRoomsResponses, ChatServiceListSpaceRoomsErrors, ThrowOnError>({ url: '/chat/spaces/{sid}/rooms', ...options });
